import { Avatar, Box, Collapse, Grid, IconButton, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import CheckBoxGroup from "./CheckBoxGroup";
import CustomAutocomplete from "./CustomAutocomplete";
import CustomSelect from "./CustomSelect";
import CustomSelectMultiple from "./CustomSelectMultiple";
import CustomTextField from "./CustomTextField";
import CustomizedDatePicker from "./DatePicker";
import RadioButtonGroupInGrid from "./RadioButtonGroupInGrid";
import CustomButton from "./CustomButton";
import Helpers from "../../helpers/helpers";
import CustomSelectChip from "./CustomSelectChip";
import CustomSelectableCard from "./CustomSelectableCard";
import { Icon } from "@iconify/react/dist/iconify.js";

export default function FilterContent({ filterData, applyFilter, resetFilter }) {
    const [openIndexes, setOpenIndexes] = useState([]);
    const [dateModalOpen, setDateModalOpen] = useState(false);

    const sortData = filterData?.length > 0 ? filterData.filter((x, idx) => x?.name === "sort_by") : [];
    const [sort, setSort] = useState("");
    const [sortBy, setSortBy] = useState("");

    useEffect(() => {
        const data = Helpers?.getSortStatusLabel(sortData?.[0]?.value || "", sortData?.[0]?.sortName1 || "", sortData?.[0]?.sortName2 || "");
        const sortTemp = data?.sort || ""
        const sortByTemp = data?.sort_by || ""
        setSort(sortTemp);
        setSortBy(sortByTemp);

    }, [filterData])

    const handleToggle = (idx) => {
        setOpenIndexes((prev) =>
            prev.includes(idx)
                ? prev.filter((i) => i !== idx)
                : [...prev, idx]
        );
    };

    return (
        <>
            <Box sx={{ p: 3, pt: 3, pb: 7 }}>
                {filterData?.length > 0 &&
                    filterData.map((item, index) => (
                        <Box key={index} sx={{ mb: 2, border: "none", borderBottom: "1px solid #E0E0E0", mt: 1, pb: 2 }}>
                            <div className="p-2">
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }} onClick={() => handleToggle(index)}>
                                    <div className="d-flex" style={{ fontWeight: 500, gap: 10 }}>{item.label} {item.type === "multiple_select" && item?.value?.length > 0 ?
                                        <Avatar sx={{ bgcolor: "#031634", color: "white", width: 20, height: 20, fontSize: "10px", }}>{item?.value?.length}</Avatar> : ""}</div>
                                    <IconButton size="small">
                                        <i className={openIndexes.includes(index) ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} />
                                    </IconButton>
                                </Box>
                                <Collapse in={openIndexes.includes(index)}>
                                    <Box>
                                        {item.type === "radio" ? (
                                            <RadioButtonGroupInGrid
                                                xs={12}
                                                sm={12}
                                                value={item?.name === "sort_by" ? Helpers?.getSortStatus(sort, sortBy, item?.sortName1, item?.sortName2) : item?.value}
                                                data={item?.data}
                                                setValue={(e) => {
                                                    if (item?.name === "sort_by") {
                                                        let data = Helpers?.getSortStatusLabel(e, item?.sortName1, item?.sortName2);
                                                        setSort(data?.sort);
                                                        setSortBy(data?.sort_by);
                                                        // Optionally call item?.onChange(e) if needed
                                                    } else {
                                                        item?.onChange(e);
                                                    }
                                                }}
                                                name={item?.name}
                                            />
                                        ) : item.type === "checkbox" ? (
                                            <CheckBoxGroup
                                                data={item?.data || []}
                                                values={item?.value || []}
                                                onChange={(e, data) => {
                                                    let prev = Array.isArray(item?.value) ? item?.value : [];
                                                    const value = data?.value;
                                                    const allValues = item?.data.filter(x => x.value !== -1 || x.label === 'all').map(x => x.value);
                                                    // If "All" is checked
                                                    if (value == -1 && e.target.checked === true) {
                                                        item?.onChange(allValues);
                                                    }
                                                    // If "All" is unchecked
                                                    else if (value == -1 && e.target.checked === false) {
                                                        item?.onChange([]);
                                                    }
                                                    // Toggle individual value
                                                    else {
                                                        let newValues;
                                                        if (prev.includes(value)) {
                                                            newValues = prev.filter(v => v !== value);
                                                        } else {
                                                            newValues = [...prev, value];
                                                        }
                                                        item?.onChange(newValues);
                                                    }
                                                }}
                                                row={true}
                                                xs={12}
                                                sm={12}
                                            />
                                        ) : item.type === "text" ? (
                                            <CustomTextField
                                                values={item?.value}
                                                onChange={(e) => item?.onChange(e)}
                                                placeholder={item?.placeholder}
                                                type={item?.inputType || 'text'}
                                            />
                                        ) : item.type === "select" ? (
                                            <><div className="pt-2"></div>
                                                <CustomSelect
                                                    data={item?.data || []}
                                                    values={item?.value || "-1"}
                                                    placeholder={item?.placeholder}
                                                    onChange={(e, value) => {
                                                        item?.onChange(value);
                                                    }}
                                                    valueName={item?.valueName}
                                                    labelName={item?.labelName} />
                                            </>

                                        ) : item.type === "multiple_select" ? (
                                            <><div className="pt-2"></div>
                                                <CustomSelectMultiple
                                                    data={item?.data || []}
                                                    values={item?.value || []}
                                                    placeholder={item?.placeholder}
                                                    onChange={(value) => {
                                                        item?.onChange(value);
                                                    }}
                                                    valueName={item?.valueName}
                                                    labelName={item?.labelName} />
                                            </>
                                        ) : item?.type === "autocomplete" ? (
                                            <CustomAutocomplete
                                                data={item?.data || []}
                                                values={item?.value}
                                                placeholder={item?.placeholder}
                                                onChange={(e, value) => {
                                                    item?.onChange(value);
                                                }}
                                                valueName={item?.valueName}
                                                labelName={item?.labelName}
                                            />
                                        ) : item?.type === "date" ? (
                                            <CustomizedDatePicker
                                                values={item?.value && new Date(item?.value)}
                                                setFormValues={(e) => item?.onChange(e)}
                                            />
                                        ) : item?.type === "date_range" ? (
                                            <Grid container spacing={2} >
                                                <Grid item sm={6} xs={12}>
                                                    <CustomizedDatePicker
                                                        values={item?.startDate && new Date(item?.startDate)}
                                                        setFormValues={(e) => item?.setStartDate(e)}
                                                    />
                                                </Grid>
                                                <Grid item sm={6} xs={12}>
                                                    <CustomizedDatePicker
                                                        values={item?.endDate && new Date(item?.endDate)}
                                                        setFormValues={(e) => item?.setEndDate(e)}
                                                        minDate={item?.startDate && new Date(item?.startDate)}
                                                    />
                                                </Grid>
                                            </Grid>
                                        ) : item?.type === "created_date" ?
                                            <>
                                                <RadioButtonGroupInGrid
                                                    xs={12}
                                                    sm={12}
                                                    value={item?.value}
                                                    data={Helpers.createDateOptions}
                                                    setValue={(e) => { item?.onChange(e) }}
                                                    name={item?.name}
                                                />
                                                {
                                                    item?.value === 'custom' &&
                                                    <Grid container spacing={2} >
                                                        <Grid item sm={6} xs={12}>
                                                            <CustomizedDatePicker
                                                                title={"From"}
                                                                values={item?.startDate && new Date(item?.startDate)}
                                                                setFormValues={(e) => item?.setStartDate(e)}
                                                            />
                                                        </Grid>
                                                        <Grid item sm={6} xs={12}>
                                                            <CustomizedDatePicker
                                                                title={"To"}
                                                                values={item?.endDate && new Date(item?.endDate)}
                                                                setFormValues={(e) => item?.setEndDate(e)}
                                                                minDate={item?.startDate && new Date(item?.startDate)}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                }
                                            </>
                                            : item?.type === "range" ?
                                                <Grid container spacing={2} >
                                                    <Grid item sm={5.5} xs={12}>
                                                        y                                                        <CustomTextField
                                                            values={item?.minValue}
                                                            onChange={(e) => item?.setMinAmount(e)}
                                                            placeholder={'0'}
                                                            type={"number"}
                                                            InputProps={{
                                                                startAdornment: <span>{item?.prefix || ''}</span>,
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item sm={1} xs={12} className="d-flex align-items-center justify-content-center">
                                                        -
                                                    </Grid>
                                                    <Grid item sm={5.5} xs={12}>
                                                        <CustomTextField
                                                            values={item?.maxValue}
                                                            onChange={(e) => item?.setMaxAmount(e)}
                                                            placeholder={'0'}
                                                            type={"number"}
                                                            InputProps={{
                                                                startAdornment: <span>{item?.prefix || ''}</span>,
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                : item?.type === "date_range" ?
                                                    <Grid container spacing={2} pt={2}>
                                                        <Grid item sm={6} xs={12}>
                                                            <CustomizedDatePicker
                                                                title={"From"}
                                                                values={item?.startDate && new Date(item?.startDate)}
                                                                setFormValues={(e) => item?.setStartDate(e)}
                                                            />
                                                        </Grid>
                                                        <Grid item sm={6} xs={12}>
                                                            <CustomizedDatePicker
                                                                title={"To"}
                                                                values={item?.endDate && new Date(item?.endDate)}
                                                                setFormValues={(e) => item?.setEndDate(e)}
                                                                minDate={item?.startDate && new Date(item?.startDate)}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    : item?.type === "select_chip" ?

                                                        <CustomSelectChip
                                                            values={item?.value}
                                                            onChange={(e, value) => {
                                                                item?.onChange(value);
                                                            }}
                                                            multiple={item?.multiple}
                                                            data={item?.data}
                                                            title={item?.title}
                                                            placeholder={item?.placeholder}
                                                            valueName={item?.valueName}
                                                            labelName={item?.labelName}
                                                            width="100%"
                                                        />
                                                        : item?.type === "select_card" ? (
                                                            item?.data?.length > 0 &&
                                                            item.data.map((x) => (
                                                                <CustomSelectableCard
                                                                    key={x.id}
                                                                    title={x.name}
                                                                    multiple={item?.multiple || false}
                                                                    description={x.subTitle}
                                                                    icon={<Icon icon={x.icon} width={24} height={24} />}
                                                                    selected={item?.selected(x.id)} // Pass the selected logic dynamically
                                                                    onSelect={() => item?.onSelect(x.id)} // Pass the onSelect handler dynamically
                                                                    disabled={false}
                                                                    width="100%"
                                                                    margin="10px 0"
                                                                    padding="15px"
                                                                />
                                                            ))
                                                        ) : null
                                        }
                                    </Box>
                                </Collapse>
                            </div>

                        </Box>
                    ))}

            </Box>
            <Stack direction="row" gap={2} justifyContent="flex-end" className="mobile-button-container">
                <CustomButton
                    title={"Reset All"}
                    variant="outlined" color="secondary"
                    press={resetFilter} textColor={"#031634"}
                    backgroundColor={"white"} />
                <CustomButton
                    title={"Apply"}
                    variant="contained"
                    color="primary" press={() => applyFilter(sort, sortBy)}
                    textColor={"white"} sx={{ mr: 1 }} />
            </Stack>
        </>

    );
}